import { compose, hoistStatics, pure } from 'recompose';

import PlusButton from './plusButton';

const enhance = compose(
  pure,
);
export default hoistStatics(enhance)(PlusButton);
